import { Banner, Col, Row, Typography } from 'darrius';
import { type TServiceProps } from '../@interfaces';

import styles from './Services.module.scss';

export const Services = ({
  title,
  servicesList,
  metrics,
  description,
}: TServiceProps) => {
  return (
    <Banner
      className={`${styles['signup-mgm__services']} space-bottom full center-sm`}
    >
      <Typography.Title size="3xl" className={styles['heading-title']}>
        {title}
      </Typography.Title>

      <Row
        className={`${styles['signup-mgm__section']} center-sm space-top space-bottom`}
      >
        {metrics.map((item) => (
          <Col className="col-sm-12 col-md-3" key={item.title}>
            <div className={styles['signup-mgm__content']}>
              <div className={styles.highlight}>
                <Typography.Subtitle size="l" className={styles.title} as="h5">
                  {item.title}
                </Typography.Subtitle>
              </div>
            </div>
            <Typography.Text className={styles.text}>
              {item.text}
            </Typography.Text>
          </Col>
        ))}
      </Row>
      <Typography.Text className={styles['services-subtitle-text']}>
        {description}
      </Typography.Text>
      <Row className="space-top space-bottom">
        {servicesList.map((item) => (
          <Col className="col-sm-4 col-md-2" key={item.text}>
            <img
              className={styles['signup-mgm__services__img']}
              src={item.img}
              alt=""
            />
            <Typography.Text className={styles['services-list-text']}>
              {item.text}
            </Typography.Text>
          </Col>
        ))}
      </Row>
    </Banner>
  );
};
